import React, { useState } from "react";
import moment from "moment";
import { toast } from "react-toastify";
import userServiceApi from "../api/userServiceApi";
import { getRequest } from "../api/http";
import { useStore } from "../store";
import { setTabData, setSkills, setSponsorList } from "../store/actions";
import { deleteRequest, postRequest, putRequest } from "../api/http";
import { vacancyKeys } from "../config";
import { contactEnumsArr } from "../config";
import { useParams } from "react-router-dom";

export function useTab() {
  const { dispatch } = useStore();
  const { micrositeId } = useParams();
  const partnername = sessionStorage.getItem("OrgName");

  const [loader, setLoader] = useState(true);
  const [postLoader, setPostLoader] = useState(false);

  const headers = {
    Authorization: `Bearer ${sessionStorage.getItem("token")}`,
  };

  const getSponsorList = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${sessionStorage.getItem("token")}`,
      };
      const response = await getRequest(
        userServiceApi.getPartnerLogo(partnername),
        headers
      );
      if (response) {
        dispatch(setSponsorList(response.data));
      }
    } catch (error) {
    }
  }

  const getSingleTabData = async (tabKey, form) => {
    try {
      setLoader(true);
      const response = await getRequest(
        contactEnumsArr.includes(tabKey)
          ? userServiceApi.getContactUsDetails(tabKey, micrositeId)
          : vacancyKeys.includes(tabKey)
            ? userServiceApi.getMicrositeDetailsVacancyTab(tabKey, micrositeId)
            : userServiceApi.getMicrositeDetailsTabs(tabKey, micrositeId),
        { headers }
      );
      if (response && response.data) {
        if (form) {
          form.resetFields();
        }
        setLoader(false);

        dispatch(
          setTabData({
            mainKey: tabKey,
            data: response.data.map((d) => {
              if (d && d.closingDate) {
                d.closingDate = moment(d.closingDate);
              }
              return d;
            }),
          })
        );
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
    }
  };

  const deleteSingleItem = async (tabKey, id, form) => {
    try {
      // setPostLoader(true);

      const response = await deleteRequest(userServiceApi.deletePartnerDetails(tabKey, id));
      if (response && response.id) {
        // getSingleTabData(tabKey, form);
        // // setLoader(true);
        // setPostLoader(false);
        // if(remove){
        //   remove(i)
        // }
        toast.success("Deleted successfully");
        setTimeout(() => {
          window.location.reload();
        }, 100);
      } else {
        // setPostLoader(false);
        toast.error("Failed to delete!!");
        // setPostLoader(false);
      }
    } catch (error) {
      toast.error(error.error);
    }
  };

  const createNewItem = async (tabKey, data, form) => {
    // console.log('createNewItem', data);
    var headerList = {};
    headerList = {
      headers: { "Content-Type": "multipart/form-data" },
      headers,
    };

    try {
      setPostLoader(true);
      const response = await postRequest(
        userServiceApi.createMicrositeTabs(tabKey), data, headerList);
      if (response) {
        setPostLoader(false);
        toast.success("Data created successfully");
        // window.location.reload();
        // setTimeout(() => {
        // }, 1000);
      } else {
        setPostLoader(false);
      }
    } catch (error) {
      setPostLoader(false);
    }
  };

  const updateItems = async (tabKey, data, isAdd, form) => {
    // console.log('updateItems', data);
    // console.log('isAdd', isAdd);
    var headerList = {};
    headerList = {
      headers: { "Content-Type": "multipart/form-data" },
      headers,
    };

    try {
      setPostLoader(true);
      const response = await putRequest(userServiceApi.updateMicrositeDetailsTabs(tabKey), data, headerList);
      if (response) {
        // setPostLoader(false);
        // getSingleTabData(tabKey, form);
        if (isAdd) {
          toast.success("Data created successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 100);
          setPostLoader(false);
        } else {
          toast.success("Data updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 100);
        }
      }
    } catch (error) {
      toast.error("Failed to add/update carousel")
    }
    finally {
      setPostLoader(false);
    }
  };

  const createNewLogoItem = async (tabKey, data, form) => {
    // console.log('createNewItem', data);
    var headerList = {};
    headerList = {
      headers: { "Content-Type": "multipart/form-data" },
      headers,
    };

    const partnerName = sessionStorage.getItem('OrgName');

    try {
      setPostLoader(true);
      const response = await putRequest(
        userServiceApi.updateLogos(partnerName, tabKey), data, headerList);
      if (response) {
        setPostLoader(false);
        getSponsorList();
        toast.success("sponser logos updated successfully");
        // getSingleTabData(tabKey, form);
        // window.location.reload();
        // setTimeout(() => {
        // }, 1000);
      } else {
        setPostLoader(false);
      }
    } catch (error) {
      setPostLoader(false);
    }
  };

  const updateLogoItems = async (tabKey, data, isAdd, form) => {
    // console.log('updateItems', data);
    // console.log('isAdd', isAdd);
    var headerList = {};
    headerList = {
      headers: { "Content-Type": "multipart/form-data" },
      headers,
    };

    const partnerName = sessionStorage.getItem('OrgName');

    try {
      setPostLoader(true);
      const response = await putRequest(userServiceApi.updateLogos(partnerName, tabKey), data, headerList);
      if (response) {
        // setPostLoader(false);
        // getSingleTabData(tabKey, form);
        if (isAdd) {
          toast.success("sponser logos updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 100);
          setPostLoader(false);
        } else {
          toast.success("sponser logos updated successfully");
          // setTimeout(() => {
          //   window.location.reload();
          // }, 100);
        }
        getSponsorList();
      } else {
        setPostLoader(false);
      }
    } catch (error) {
      setPostLoader(false);
    }
  };

  const callMicroServices = (tabKey, formData, form) => {
    // console.log("callMicroservices", tabKey, formData, form)
    if (tabKey === "corousel") {
      if (formData["newData"]) {
        createNewItem(tabKey, formData["newData"], form);
      }
      if (formData["extraData"]) {
        updateItems(tabKey, formData["extraData"], true, form);
      }
      if (formData["editedData"]) {
        updateItems(tabKey, formData["editedData"], false, form);
      }
    }
    // console.log("formData", formData);
    // console.log("form", form)
    if (tabKey === "logo") {
      if (formData["newData"]) {
        createNewLogoItem(tabKey, formData["newData"], form);
      }
      if (formData["extraData"]) {
        updateLogoItems(tabKey, formData["extraData"], true, form);
      }
      if (formData["editedData"]) {
        updateLogoItems(tabKey, formData["editedData"], false, form);
      }
    }

  };

  const getSkills = async () => {
    try {
      const response = await getRequest(userServiceApi.getAllSkills(), {
        headers,
      });
      if (response && response.data) {
        dispatch(setSkills(response.data));
      }
    } catch (error) {
      console.error(error);
    }
  };

  return {
    getSingleTabData,
    deleteSingleItem,
    callMicroServices,
    getSkills,
    getSponsorList,
    dataLoader: loader,
    postLoader,
  };
}
